import React from 'react';
export function GDPRSection() {
  return <section className="w-full bg-dark py-12 px-4 sm:px-6 lg:px-8" data-id="element-40">
      <div className="max-w-7xl mx-auto" data-id="element-41">
        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-10" data-id="element-42">
          {/* Contact */}
          <div data-id="element-43">
            <h3 className="text-sm font-bold text-light tracking-widest uppercase mb-4" data-id="element-44">
              CONTACT
            </h3>
            <p className="text-gray-300 text-sm leading-relaxed mb-1" data-id="element-45">
              DR. TIANU V. CORNELIA - CABINET MEDICAL INDIVIDUAL, CUI: 32459568,
            </p>
            <p className="text-gray-300 text-sm leading-relaxed mb-1" data-id="element-46">
              Adresa: STR. BABA NOVAC, NR.2, BL.CABINET NR 2, ET.1, SECT. 3,
              BUCUREȘTI, ROMÂNIA
            </p>
            <p className="text-gray-300 text-sm leading-relaxed mb-1" data-id="element-47">
              Telefon:{' '}
              <a href="tel:0213245880" className="text-gray-300 hover:text-light transition-colors" data-id="element-48">
                0213245880
              </a>
            </p>
            <p className="text-gray-300 text-sm leading-relaxed" data-id="element-49">
              email:{' '}
              <a href="mailto:cmi_tianu@yahoo.com" className="text-gray-300 hover:text-light transition-colors" data-id="element-50">
                cmi_tianu@yahoo.com
              </a>
            </p>
          </div>

          {/* Legal */}
          <div data-id="element-51">
            <h3 className="text-sm font-bold text-light tracking-widest uppercase mb-4" data-id="element-52">
              LEGAL
            </h3>
            <ul className="space-y-2" data-id="element-53">
              <li data-id="element-54">
                <a href="https://app.gohighlevel.com/v2/preview/qBmkoDqeoevwJyksfOSF" className="text-gray-300 text-sm hover:text-light transition-colors" data-id="element-55">
                  TERMENI ȘI CONDIȚII
                </a>
              </li>
              <li data-id="element-56">
                <a href="https://app.gohighlevel.com/v2/preview/KuZHd5J3LvH7tKRBf9Sp" className="text-gray-300 text-sm hover:text-light transition-colors" data-id="element-57">
                  POLITICA DE CONFIDENȚIALITATE
                </a>
              </li>
              <li data-id="element-58">
                <a href="https://app.gohighlevel.com/v2/preview/66slZulLFGcIwMdPUt0r" className="text-gray-300 text-sm hover:text-light transition-colors" data-id="element-59">
                  POLITICA DE COOKIES
                </a>
              </li>
              <li data-id="element-60">
                <a href="https://anpc.ro" className="text-gray-300 text-sm hover:text-light transition-colors" data-id="element-61">
                  ANPC
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div data-id="element-62">
            <h3 className="text-sm font-bold text-light tracking-widest uppercase mb-4" data-id="element-63">
              SOCIAL MEDIA
            </h3>
            <ul className="space-y-3" data-id="element-64">
              <li data-id="element-65">
                <a href="https://chat.whatsapp.com/CKGpQdMfE9Y5j1eimB7FlH?mode=gi_t" className="flex items-center gap-3 text-gray-300 text-sm hover:text-light transition-colors" data-id="element-66">
                  <svg className="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24" data-id="element-67">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-68" />
                  </svg>
                  WhatsApp
                </a>
              </li>
              <li data-id="element-69">
                <a href="https://www.youtube.com/@drcorneliatianu/videos" className="flex items-center gap-3 text-gray-300 text-sm hover:text-light transition-colors" data-id="element-70">
                  <svg className="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24" data-id="element-71">
                    <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" data-id="element-72" />
                  </svg>
                  YouTube
                </a>
              </li>
              <li data-id="element-73">
                <a href="https://www.facebook.com/doctorcorneliatianu" className="flex items-center gap-3 text-gray-300 text-sm hover:text-light transition-colors" data-id="element-74">
                  <svg className="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24" data-id="element-75">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-76" />
                  </svg>
                  Facebook
                </a>
              </li>
              <li data-id="element-77">
                <a href="https://www.instagram.com/corneliatianu/" className="flex items-center gap-3 text-gray-300 text-sm hover:text-light transition-colors" data-id="element-78">
                  <svg className="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24" data-id="element-79">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" data-id="element-80" />
                  </svg>
                  Instagram
                </a>
              </li>
              <li data-id="element-81">
                <a href="https://www.tiktok.com/@drcorneliatianu" className="flex items-center gap-3 text-gray-300 text-sm hover:text-light transition-colors" data-id="element-82">
                  <svg className="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24" data-id="element-83">
                    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" data-id="element-84" />
                  </svg>
                  TikTok
                </a>
              </li>
            </ul>
          </div>

          {/* ANPC Badges */}
          <div className="flex flex-col items-start gap-4" data-id="element-85">
            <a href="https://anpc.ro/ce-este-sal/" className="block hover:opacity-80 transition-opacity" data-id="element-86">
              <img src="https://cdn.magicpatterns.com/uploads/5seGEbFX1NYZvXELj2vFYj/ANPC.webp" alt="ANPC - Soluționarea Alternativă a Litigiilor" className="h-16 rounded-lg" data-id="element-87" />
            </a>
            <a href="https://ec.europa.eu/consumers/odr" className="block hover:opacity-80 transition-opacity" data-id="element-88">
              <img src="https://cdn.magicpatterns.com/uploads/n6XWFFtxihHT4Tv4bZe1Gx/Solutionarea_Online_a_Litigiilor.jpg" alt="Soluționarea Online a Litigiilor" className="h-16 rounded-lg" data-id="element-89" />
            </a>
          </div>
        </div>

        {/* Divider + Copyright */}
        <div className="border-t border-gray-600 pt-6" data-id="element-90">
          <p className="text-center text-gray-400 text-xs" data-id="element-91">
            © Copyright {new Date().getFullYear()}. DR.TIANU V. CORNELIA -
            CABINET MEDICAL INDIVIDUAL. Toate drepturile rezervate.
          </p>
        </div>
      </div>
    </section>;
}